import { FlexFileError } from './FlexFileError';

import {ReportDataService} from '../../report-data.service';

export class OverlappingReportCalDatesError extends FlexFileError {

  protected reportService: ReportDataService;

  constructor(reportService: ReportDataService, additionalData) {
    super(reportService, 'Overlapping date ranges in Reporting Calendar', 'OVERLAPPING_DATES', 0, true, additionalData);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/errors/OverlappingReportCalDatesError.ts